import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import DefaultAvatar from "assets/images/default-avatar.svg";
// import LazyImage from "components/elements/LazyImage";

type IProps = {
	contributor: ContributorResponseResource;
	avatarUrl: string | null;
	color?: "white" | "neutral";
};

export default function ContributorBadge(props: IProps) {
	return (
		<div className={classes["root"]}>
			<img src={props.avatarUrl ?? DefaultAvatar} className={classes["avatar"]} alt={`${props.contributor.firstName} ${props.contributor.lastName}`} />
			<div className={classes["info"]}>
				{(props.contributor.firstName || props.contributor.lastName) && (
					<div className={classes["fullname"]}>
						<Typography type="p" weight="bold" size="small" className={classes["name"]} color={props.color}>
							{props.contributor.firstName}
						</Typography>
						<Typography type="p" weight="bold" size="small" className={classes["name"]} color={props.color}>
							{props.contributor.lastName}
						</Typography>
					</div>
				)}
				{props.contributor.companyName && (
					<Typography type="p" weight="bold" size="small" className={classes["company-name"]} color={props.color}>
						{props.contributor.companyName}
					</Typography>
				)}
			</div>
		</div>
	);
}
